import { Checkbox, Grid, Paper } from "@material-ui/core";
import { useState, useEffect, useCallback, useContext, Suspense, useRef } from "react";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import EventNoteIcon from "@material-ui/icons/EventNote";

import "./ChristmasClub.css";
import { AuthContext, PaycheckContext, ThemeContext } from "../../../../../../../../contexts";
import PlanHeader from "../../../../../../../shared/enrollment/planCode/PlanHeader";
import { CustomInput } from "../../../../../../../shared/customInput";
import { Button } from "@material-ui/core";
import { dollarize } from "../../../../../../../../utils/commonFunctions/dollar";

import {
	dateFormateToMonthDayYear,
	dateTimeZoneConverter,
	getCurrentDate
} from "../../../../../../../../utils/commonFunctions/date";
import { EnrollmentSchema } from "../../../../../../../../@types/enrollment.types copy";
import { Validation } from "../../../../../../../../@types/validation.types";
import { AdminEnrollmentInitDataQuery } from "../../../../../../../../utils/api/pages/enrollmentInit";
import useRouteParam from "../../../../../../../../hooks/useRouteParam";
import { CommonDetails, Enrollment } from "../../../../../../../../@types/enrollment.types";
import { api } from "../../../../../../../../utils/api";
import {
	ApproveEnrollment,
	ApproveHOOEnrollment
} from "../../../../../../../../@types/components/enrollmentProps.types";
import { LazyApproveEnrollment } from "../../../../../..";
import { Member } from "../../../../../../../../@types/member.types";
import { helpingOurOwnLogo } from "../../../../../../../../assets";
import {
	ApproveEnrollmentPayload,
	ApproveHOOEnrollmentPayload
} from "../../../../../../../../utils/api/enrollment/enrollment";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { useNavigate } from "react-router-dom";
import { trackPromise } from "react-promise-tracker";

import SendIcon from "@material-ui/icons/Send";
import { getCommonDetails } from "../../../../../../../../utils/commonFunctions/groupEnrollment/enrollmentPayload";
import encryption from "../../../../../../../../utils/commonFunctions/encryption";
import { ENROLLMENT_STATUS } from "../../../../../../../../constants/enrollment/enrollmentStatus";
import { Plan } from "../../../../../../../../@types/plan.types";

// For Open Enrollments
// const ChristmasClub = (): JSX.Element => {
// 	const { theme, setTheme } = useContext(ThemeContext);
// 	const { paycheck, setPaycheck } = useContext(PaycheckContext);
// 	const [enrollments, setEnrollments] = useState<Enrollment[]>([]);
// 	const [waiveReason, setWaiveReason] = useState("");
// 	const [member, setMember] = useState<Member | null>(null);
// 	const navigate = useNavigate();
// 	const queryPlanCode = useRouteParam("pc");
// 	const queryGroupNumber = useRouteParam("gn");
// 	const querySSN = useRouteParam("qs");
// 	const [approveEnrollment, setApproveEnrollment] = useState<ApproveEnrollment>();
// 	const [enrollmentDate, setEnrollmentDate] = useState("");
// 	const [enrollmentCommonDetail, setEnrollmentCommonDetail] = useState<CommonDetails>();
// 	const [premiumAmount, setPremiumAmount] = useState<null | number>(null);
// 	const [plan, setPlan] = useState<Plan>();
// 	const [validation, setValidation] = useState<Validation>({
// 		approvedEnrollment: {},
// 		status: "invalid"
// 	});
// 	const _validation = useRef<Validation>();

// 	const handleApproveEnrollmentChange = useCallback(
// 		(
// 			event: React.ChangeEvent<
// 				| HTMLInputElement
// 				| {
// 						name?: string | undefined;
// 						value: unknown;
// 				  }
// 			>,
// 			child?: React.ReactNode
// 		) => {
// 			const { name, value } = event.target;
// 			// console.log(value);
// 			setApproveEnrollment(
// 				Object.assign({}, approveEnrollment, {
// 					[name as string]: value
// 				})
// 			);
// 		},
// 		[approveEnrollment]
// 	);

// 	// const handleApproveEnrollmentDateChange = useCallback(
// 	// 	(date?: MaterialUiPickersDate, value?: string | null | undefined) => {
// 	// 		const selectedDate = new Date(date as any);

// 	// 		const parsedDate =
// 	// 			selectedDate.getFullYear() + "-" + (selectedDate.getMonth() + 1) + "-" + selectedDate.getDate();

// 	// 		setApproveEnrollment(
// 	// 			Object.assign({}, approveEnrollment, {
// 	// 				effective_date: parsedDate
// 	// 			})
// 	// 		);
// 	// 	},
// 	// 	[approveEnrollment]
// 	// );

// 	const handleApproveEnrollmentDateChange = useCallback(
// 		(date?: MaterialUiPickersDate, value?: string | null | undefined) => {
// 			const parsedDate = date as unknown as string;
// 			setApproveEnrollment(Object.assign({}, approveEnrollment, { effective_date: parsedDate }));
// 		},
// 		[approveEnrollment]
// 	);

// 	const handleValidation = useCallback(async () => {
// 		_validation.current = {
// 			...validation,
// 			approveEnrollment: {},
// 			status: "invalid"
// 		};
// 		let flag = true;

// 		if (approveEnrollment === undefined) {
// 			_validation.current["status"] = "invalid";
// 			flag = false;
// 		}

// 		if (!approveEnrollment?.enrollment_status || approveEnrollment?.enrollment_status === "SUBMITTED") {
// 			_validation.current.approveEnrollment["enrollment_status"] = "Enrollment Status is required";
// 			_validation.current.status = "invalid";
// 			flag = false;
// 		}

// 		if (approveEnrollment?.enrollment_status === "ACTIVE" && approveEnrollment?.effective_date === null) {
// 			_validation.current.approveEnrollment["effective_date"] =
// 				"For active enrollment effective date is required";
// 			_validation.current.status = "invalid";
// 			flag = false;
// 		}

// 		if (flag === true) _validation.current["status"] = "valid";
// 		else {
// 			_validation.current["status"] = "invalid";
// 			// alert("Please, fill effective date field !");
// 		}
// 		setValidation(Object.assign({}, _validation.current));
// 		return _validation.current.status;
// 	}, [approveEnrollment, validation]);

// 	const handleMemberDetailsRedirection = useCallback(() => {
// 		const pathname = `/employer/member?gn=${queryGroupNumber}&&qs=${
// 			encryption(querySSN as string) as string
// 		}&&to=benefits`;
// 		navigate(pathname);
// 	}, [navigate, queryGroupNumber, querySSN]);

// 	const handleSubmitEnrollmentClick = useCallback(
// 		async (event: React.FormEvent<HTMLButtonElement>) => {
// 			console.log("approve", approveEnrollment);
// 			// eslint-disable-next-line @typescript-eslint/no-unused-vars
// 			const validation = await handleValidation();
// 			if (validation === "valid") {
// 				if (approveEnrollment === undefined || enrollmentCommonDetail === undefined) {
// 					return;
// 				}

// 				const { effective_date } = approveEnrollment;

// 				const effectiveDate = new Date(effective_date as unknown as Date);

// 				const _approveEnrollmentPayload = {
// 					...approveEnrollment,
// 					effective_date:
// 						effectiveDate.getFullYear() +
// 						"-" +
// 						(effectiveDate.getMonth() + 1) +
// 						"-" +
// 						effectiveDate.getDate()
// 				};

// 				const approveEnrollmentPayload: ApproveEnrollmentPayload = {
// 					..._approveEnrollmentPayload,
// 					common_detail: enrollmentCommonDetail,
// 					dependent_standard_details: [],
// 					covered_dependent_SSNs: []
// 				};
// 				const response = await trackPromise(api.enrollments.approveEnrollment(approveEnrollmentPayload));
// 				if (response) {
// 					const { enrollment_status } = response.result;

// 					enrollment_status === ENROLLMENT_STATUS.active
// 						? alert("Christmas Club Form Approval Submitted!")
// 						: enrollment_status === ENROLLMENT_STATUS.rejected
// 						? alert("Christmas Club Form Approval has been Rejected!")
// 						: alert(null);

// 					// Redirection to Member Family Details
// 					handleMemberDetailsRedirection();
// 				}
// 			}
// 		},
// 		[approveEnrollment, enrollmentCommonDetail, handleMemberDetailsRedirection, handleValidation]
// 	);

// 	const getAdminEnrollmentInitData = useCallback(async () => {
// 		if (!queryGroupNumber || !queryPlanCode || !querySSN) {
// 			return;
// 		}

// 		const query: AdminEnrollmentInitDataQuery = {
// 			insured_SSN: querySSN as string,
// 			plan_code: queryPlanCode as string,
// 			group_number: queryGroupNumber as number
// 		};
// 		const { theme, enrollments, paycheck } = await trackPromise(api.pages.getAdminEnrollmentInitData(query));

// 		setPlan(enrollments[0].plan);

// 		setEnrollments(Object.assign([], enrollments));
// 		setTheme(Object.assign({}, theme));
// 		setPaycheck(Object.assign({}, paycheck));
// 		setPremiumAmount(enrollments[0].premium_amount);
// 		setMember(Object.assign({}, enrollments[0].employee));
// 		setApproveEnrollment((prevApproveEnrollment: ApproveEnrollment | undefined) =>
// 			Object.assign({}, prevApproveEnrollment, {
// 				_id: enrollments[0]._id,
// 				plan_code: enrollments[0].plan_code,
// 				insured_SSN: enrollments[0].insured_SSN,
// 				current_paycheck_id: paycheck._id,
// 				enrollment_status: enrollments[0].enrollment_status,
// 				effective_date: enrollments[0].effective_date
// 			})
// 		);
// 		setEnrollmentCommonDetail(getCommonDetails(enrollments[0]));
// 		setEnrollmentDate(enrollments[0].enrollment_date as unknown as string);
// 	}, [queryGroupNumber, queryPlanCode, querySSN, setPaycheck, setTheme]);

// 	useEffect(() => {
// 		getAdminEnrollmentInitData();
// 	}, [getAdminEnrollmentInitData]);

// 	return (
// 		<Suspense fallback={<div />}>
// 			<div className="theme-container">
// 				<Paper className="paper-container">
// 					<div className="header-image-container">
// 						<PlanHeader
// 							planName={plan?.plan_name as unknown as string}
// 							planCode={plan?.plan_code as unknown as string}
// 						/>
// 					</div>
// 					<div className="theme-plan-section-margin" />
// 					<div className="theme-plan-icon-item-container">
// 						<div>
// 							<CreateOutlinedIcon className="theme-plan-point-icon" />
// 						</div>
// 						<div className="theme-plan-point-text">
// 							Brookshire Brothers Christmas Club collects all elected deducts for each year from December
// 							until October.
// 						</div>
// 					</div>
// 					<br></br>
// 					<div className="theme-plan-icon-item-container">
// 						<div>
// 							<CreateOutlinedIcon className="theme-plan-point-icon" />
// 						</div>
// 						<div className="theme-plan-point-text">
// 							This authorization is to withhold the following elected amount for Brookshire Brothers
// 							Christmas Club from my weekly or monthly payroll check.
// 						</div>
// 					</div>
// 					<br></br>
// 					<Grid container className="theme-plan-section-margin">
// 						<Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
// 							<div className="details-form-row">
// 								<div className="details-form-label  required">Employee ID</div>
// 								<CustomInput value={member?.member_id} />
// 							</div>
// 						</Grid>
// 						<Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
// 							<div className="details-form-row">
// 								<div className="details-form-label">First Name</div>
// 								<CustomInput value={member?.first_name} />
// 							</div>
// 						</Grid>
// 						<Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
// 							<div className="details-form-row">
// 								<div className="details-form-label">Last Name</div>
// 								<CustomInput value={member?.last_name} />
// 							</div>
// 						</Grid>
// 						<Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
// 							<div className="details-form-row">
// 								<div className="details-form-label">SSN</div>
// 								<CustomInput value={member?.SSN} />
// 							</div>
// 						</Grid>
// 						<Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
// 							<div className="details-form-row">
// 								<div className="details-form-label">Department</div>
// 								<CustomInput value={member?.location?.location_name} />
// 							</div>
// 						</Grid>
// 					</Grid>
// 					<div className="details-form-row" style={{ marginTop: "2rem", width: "100%" }}>
// 						{/* <div className="details-form-label  required">
// 							The following is the elected weekly amount (Minimum amount is $3.00 per week or $13.00 per
// 							month).
// 						</div> */}
// 						<div className="details-form-label  required">
// 							The following is the elected amount I wish to be taken out of each paycheck (Minimum amount
// 							is $3.00 per week or $13.00 per month).
// 						</div>
// 						<CustomInput value={premiumAmount ? dollarize(premiumAmount) : null} disabled />
// 					</div>
// 					<div className="theme-plan-option-content theme-plan-section-margin">
// 						<Checkbox defaultChecked style={{ paddingLeft: 0 }} />
// 						<p className="theme-plan-checkbox-label">
// 							<strong>
// 								I understand that this savings plan will be paid out in November through payroll after
// 								the Christmas Club year is complete or upon my termination. If I terminate at any time
// 								during the plan year, I understand that I will receive my full contribution amount
// 								refunded at the earliest possible date after the termination paperwork has been received
// 								and processed by Human Resources.
// 							</strong>
// 						</p>
// 					</div>
// 					<div className="theme-plan-section-margin" />
// 					<div className="theme-plan-icon-item-container">
// 						<div>
// 							<EventNoteIcon className="event-icon" style={{ color: theme.primary_color }} />
// 						</div>
// 						<div className="theme-plan-text">
// 							<strong>Note:</strong> All interest earned on the Christmas Club account will be donated to
// 							Brookshire Brothers Helping Our Own to provide funding to employee owners in need and/or
// 							educational scholarships to employees or children of employees.
// 						</div>
// 					</div>
// 					<div className="theme-plan-section-margin" />
// 					<Grid container className="theme-plan-section-margin">
// 						<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
// 							<div className="details-form-row">
// 								<div className="details-form-label  required">Signature</div>
// 								<CustomInput value={member?.first_name + " " + member?.last_name} disabled />
// 							</div>
// 						</Grid>
// 						<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
// 							<div className="details-form-row">
// 								<div className="details-form-label  required">Date</div>
// 								<CustomInput
// 									value={
// 										dateTimeZoneConverter(
// 											approveEnrollment
// 												? dateFormateToMonthDayYear(enrollmentDate)
// 												: getCurrentDate()
// 										) as string
// 									}
// 									disabled
// 								/>
// 							</div>
// 						</Grid>
// 					</Grid>
// 					<div
// 						className="theme-divider-grad-mask"
// 						style={{
// 							background: `linear-gradient(90deg, ${theme.primary_color} 0 55%, transparent 0 100%) 0 0 / 2rem 1rem`
// 						}}
// 					/>
// 					{approveEnrollment ? (
// 						<>
// 							<Suspense fallback={<div />}>
// 								<LazyApproveEnrollment
// 									enrollmentDate={enrollmentDate}
// 									approveEnrollment={approveEnrollment}
// 									handleApproveEnrollmentChange={handleApproveEnrollmentChange}
// 									handleApproveEnrollmentDateChange={handleApproveEnrollmentDateChange}
// 									validation={validation}
// 								/>
// 							</Suspense>
// 							<div className="theme-plan-section-margin" />
// 							<div className="enrollment-submit-button-container" id="enrollment-submit-button-container">
// 								<Button
// 									className="button-green"
// 									onClick={handleSubmitEnrollmentClick}
// 									variant="contained"
// 									style={{
// 										pointerEvents: "unset"
// 									}}
// 								>
// 									<span className="button-label-with-icon">Submit</span>
// 									<span>
// 										<SendIcon className="button-icon" />
// 									</span>
// 								</Button>
// 							</div>
// 						</>
// 					) : null}
// 				</Paper>
// 			</div>
// 		</Suspense>
// 	);
// };

// export default ChristmasClub;

// For Always Open Enrollments
const ChristmasClub = (): JSX.Element => {
	const { theme, setTheme } = useContext(ThemeContext);
	const navigate = useNavigate();
	const { paycheck, setPaycheck } = useContext(PaycheckContext);
	const [enrollmentDate, setEnrollmentDate] = useState("");
	const [member, setMember] = useState<Member | null>(null);
	const [approveCCEEnrollment, setApproveCCEEnrollment] = useState<ApproveHOOEnrollment>();
	const [CCEEnrollment, setCCEEnrollment] = useState<Enrollment | null>(null);
	const queryPlanCode = useRouteParam("pc");
	const queryGroupNumber = useRouteParam("gn");
	const querySSN = useRouteParam("qs");
	const [premiumAmount, setPremiumAmount] = useState<number | null>(null);
	const [plan, setPlan] = useState<Plan>();
	const [validation, setValidation] = useState<Validation>({
		approveCCEEnrollment: {},
		status: "invalid"
	});
	const _validation = useRef<Validation>();

	const handleApproveHOOEnrollmentChange = useCallback(
		(
			event: React.ChangeEvent<
				| HTMLInputElement
				| {
						name?: string | undefined;
						value: unknown;
				  }
			>,
			child?: React.ReactNode
		) => {
			const { name, value } = event.target;
			setApproveCCEEnrollment(
				Object.assign({}, approveCCEEnrollment, {
					[name as string]: value
				})
			);
		},
		[approveCCEEnrollment]
	);

	const handleValidation = useCallback(async () => {
		_validation.current = {
			...validation,
			approveCCEEnrollment: {},
			status: "invalid"
		};
		let flag = true;

		// console.log("In handle Validation", approveCCEEnrollment);

		if (approveCCEEnrollment === undefined) {
			_validation.current["status"] = "invalid";
			flag = false;
		}

		if (
			(approveCCEEnrollment?.enrollment_status !== "ACTIVE" &&
				approveCCEEnrollment?.enrollment_status !== "REJECTED") ||
			approveCCEEnrollment?.enrollment_status.length === 0
		) {
			_validation.current.approveCCEEnrollment["enrollment_status"] = "Enrollment Status is required";
			_validation.current.status = "invalid";
			flag = false;
		}

		if (approveCCEEnrollment?.enrollment_status === "ACTIVE" && !approveCCEEnrollment?.effective_date) {
			_validation.current.approveCCEEnrollment["effective_date"] =
				"For active enrollment effective date is required";
			_validation.current.status = "invalid";
			flag = false;
		}

		if (flag === true) _validation.current["status"] = "valid";
		else {
			_validation.current["status"] = "invalid";
			// alert("Please, fill effective date field !");
		}
		setValidation(Object.assign({}, _validation.current));
		return _validation.current.status;
	}, [approveCCEEnrollment, validation]);

	const handleMemberDetailsRedirection = useCallback(() => {
		const pathname = `/employer/member?gn=${queryGroupNumber}&&qs=${
			encryption(querySSN as string) as string
		}&&to=benefits`;
		navigate(pathname);
	}, [navigate, queryGroupNumber, querySSN]);

	const handleSubmitEnrollmentClick = useCallback(
		async (event: React.FormEvent<HTMLButtonElement>) => {
			// console.log("approve", approveCCEEnrollment);
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			const validation = await handleValidation();
			// console.log("validation", validation);
			if (validation === "valid") {
				if (approveCCEEnrollment === undefined) {
					return;
				}

				const { effective_date } = approveCCEEnrollment;

				const effectiveDate = new Date(effective_date as unknown as Date);

				const approveHOOEnrollmentPayload: ApproveHOOEnrollmentPayload = {
					...approveCCEEnrollment,
					effective_date:
						effectiveDate.getFullYear() +
						"-" +
						(effectiveDate.getMonth() + 1) +
						"-" +
						effectiveDate.getDate()
				};
				const response = await trackPromise(api.enrollments.approveHOOEnrollment(approveHOOEnrollmentPayload));

				// console.log("response", response);
				if (response) {
					const { enrollment_status } = response;

					enrollment_status === ENROLLMENT_STATUS.active
						? alert("Christmas Club launch enrollment Submitted!")
						: enrollment_status === ENROLLMENT_STATUS.rejected
						? alert("Christmas Club launch enrollment has been Rejected!")
						: alert(null);

					handleMemberDetailsRedirection();
				}
			}
			// if (approveCCEEnrollment === undefined) {
			// 	return;
			// }
			// const approveHOOEnrollmentPayload: ApproveHOOEnrollmentPayload = approveCCEEnrollment;
			// const response = await api.enrollments.approveCCEEnrollment(approveHOOEnrollmentPayload);
			// if (response) {
			// 	navigate(-1);
			// }
		},
		[approveCCEEnrollment, handleMemberDetailsRedirection, handleValidation]
	);

	// const handleApproveEnrollmentDateChange = useCallback(
	// 	(date?: MaterialUiPickersDate, value?: string | null | undefined) => {
	// 		const selectedDate = new Date(date as any);

	// 		const parsedDate =
	// 			selectedDate.getFullYear() + "-" + (selectedDate.getMonth() + 1) + "-" + selectedDate.getDate();

	// 		setApproveCCEEnrollment(
	// 			Object.assign({}, approveCCEEnrollment, {
	// 				effective_date: parsedDate
	// 			})
	// 		);
	// 	},
	// 	[approveCCEEnrollment]
	// );

	const handleApproveEnrollmentDateChange = useCallback(
		(date?: MaterialUiPickersDate, value?: string | null | undefined) => {
			const parsedDate = date as unknown as string;
			setApproveCCEEnrollment(Object.assign({}, approveCCEEnrollment, { effective_date: parsedDate }));
		},
		[approveCCEEnrollment]
	);

	const getAdminEnrollmentInitData = useCallback(async () => {
		if (!queryGroupNumber || !queryPlanCode || !querySSN) {
			return;
		}
		//getAdminEnrollmentInitData();
		const query: AdminEnrollmentInitDataQuery = {
			insured_SSN: querySSN as string,
			plan_code: queryPlanCode as string,
			group_number: queryGroupNumber as number
		};
		const { theme, enrollments, paycheck } = await trackPromise(api.pages.getAdminEnrollmentInitData(query));

		setPlan(enrollments[0].plan);

		// console.log("====enrollments=>", enrollments[0]?.plan);
		setCCEEnrollment(Object.assign({}, enrollments[0]));

		setPremiumAmount(enrollments[0].premium_amount);
		setApproveCCEEnrollment(
			Object.assign(
				{},
				{
					group_number: queryGroupNumber as number,
					current_paycheck_id: paycheck._id as string,
					_id: enrollments[0]._id as string,
					plan_code: enrollments[0].plan_code,
					insured_SSN: enrollments[0].employee?.SSN as string,
					premium_amount: enrollments[0].premium_amount,
					effective_date: enrollments[0].effective_date
						? (enrollments[0].effective_date as unknown as string)
						: null,
					enrollment_status: enrollments[0].enrollment_status
				}
			)
		);
		// console.log("enrollments[0]", enrollments[0].enrollment_date);
		setEnrollmentDate(enrollments[0].enrollment_date as unknown as string);
		setMember(Object.assign({}, enrollments[0].employee));
		setTheme(Object.assign({}, theme));
		setPaycheck(Object.assign({}, paycheck));
	}, [queryGroupNumber, queryPlanCode, querySSN, setPaycheck, setTheme]);

	useEffect(() => {
		getAdminEnrollmentInitData();
	}, [getAdminEnrollmentInitData]);

	return (
		<Suspense fallback={<div />}>
			<div className="theme-container">
				<Paper className="paper-container">
					<div className="header-image-container">
						<PlanHeader
							planName={plan?.plan_name as unknown as string}
							planCode={plan?.plan_code as unknown as string}
						/>
					</div>
					<div className="theme-plan-section-margin" />
					<div className="theme-plan-icon-item-container">
						<div>
							<CreateOutlinedIcon className="theme-plan-point-icon" />
						</div>
						<div className="theme-plan-point-text">
							Brookshire Brothers Christmas Club collects all elected deducts for each year from December
							until October.
						</div>
					</div>
					<br></br>
					<div className="theme-plan-icon-item-container">
						<div>
							<CreateOutlinedIcon className="theme-plan-point-icon" />
						</div>
						<div className="theme-plan-point-text">
							This authorization is to withhold the following elected amount for Brookshire Brothers
							Christmas Club from my weekly or monthly payroll check.
						</div>
					</div>
					<br></br>
					<Grid container className="theme-plan-section-margin">
						<Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
							<div className="details-form-row">
								<div className="details-form-label  required">Employee ID</div>
								<CustomInput value={member?.member_id} />
							</div>
						</Grid>
						<Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
							<div className="details-form-row">
								<div className="details-form-label">First Name</div>
								<CustomInput value={member?.first_name} />
							</div>
						</Grid>
						<Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
							<div className="details-form-row">
								<div className="details-form-label">Last Name</div>
								<CustomInput value={member?.last_name} />
							</div>
						</Grid>
						<Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
							<div className="details-form-row">
								<div className="details-form-label">SSN</div>
								<CustomInput value={member?.SSN} />
							</div>
						</Grid>
						<Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
							<div className="details-form-row">
								<div className="details-form-label">Department</div>
								<CustomInput value={member?.location?.location_name} />
							</div>
						</Grid>
					</Grid>
					<div className="details-form-row" style={{ marginTop: "2rem", width: "100%" }}>
						{/* <div className="details-form-label  required">
							The following is the elected weekly amount (Minimum amount is $3.00 per week or $13.00 per
							month).
						</div> */}
						<div className="details-form-label  required">
							The following is the elected amount I wish to be taken out of each paycheck (Minimum amount
							is $3.00 per week or $13.00 per month).
						</div>
						<CustomInput value={premiumAmount ? dollarize(premiumAmount) : null} disabled />
					</div>
					<div className="theme-plan-option-content theme-plan-section-margin">
						<Checkbox defaultChecked style={{ paddingLeft: 0 }} />
						<p className="theme-plan-checkbox-label">
							<strong>
								I understand that this savings plan will be paid out in November through payroll after
								the Christmas Club year is complete or upon my termination. If I terminate at any time
								during the plan year, I understand that I will receive my full contribution amount
								refunded at the earliest possible date after the termination paperwork has been received
								and processed by Human Resources.
							</strong>
						</p>
					</div>
					<div className="theme-plan-section-margin" />
					<div className="theme-plan-icon-item-container">
						<div>
							<EventNoteIcon className="event-icon" style={{ color: theme.primary_color }} />
						</div>
						<div className="theme-plan-text">
							<strong>Note:</strong> All interest earned on the Christmas Club account will be donated to
							Brookshire Brothers Helping Our Own to provide funding to employee owners in need and/or
							educational scholarships to employees or children of employees.
						</div>
					</div>
					<div className="theme-plan-section-margin" />
					<Grid container className="theme-plan-section-margin">
						<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
							<div className="details-form-row">
								<div className="details-form-label  required">Signature</div>
								<CustomInput value={member?.first_name + " " + member?.last_name} disabled />
							</div>
						</Grid>
						<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
							<div className="details-form-row">
								<div className="details-form-label  required">Date</div>
								<CustomInput
									value={
										dateTimeZoneConverter(
											approveCCEEnrollment
												? dateFormateToMonthDayYear(enrollmentDate)
												: getCurrentDate()
										) as string
									}
									disabled
								/>
							</div>
						</Grid>
					</Grid>
					<div
						className="theme-divider-grad-mask"
						style={{
							background: `linear-gradient(90deg, ${theme.primary_color} 0 55%, transparent 0 100%) 0 0 / 2rem 1rem`
						}}
					/>
					{approveCCEEnrollment ? (
						<>
							<Suspense fallback={<div />}>
								<LazyApproveEnrollment
									handleApproveEnrollmentDateChange={handleApproveEnrollmentDateChange}
									enrollmentDate={enrollmentDate}
									approveEnrollment={approveCCEEnrollment}
									handleApproveEnrollmentChange={handleApproveHOOEnrollmentChange}
									validation={validation}
								/>
							</Suspense>
							<div className="theme-plan-section-margin" />
							<div className="enrollment-submit-button-container" id="enrollment-submit-button-container">
								<Button
									className="button-green"
									onClick={handleSubmitEnrollmentClick}
									variant="contained"
									style={{
										pointerEvents: "unset"
									}}
								>
									<span className="button-label-with-icon">Submit</span>
									<span>
										<SendIcon className="button-icon" />
									</span>
								</Button>
							</div>
						</>
					) : null}
				</Paper>
			</div>
		</Suspense>
	);
};

export default ChristmasClub;
